export default "__VITE_ASSET__81d4a9db__"